---
meta:
  - title: Generar facturas electrónicas - IUSPRO Docs
  - description: Aprende a generar facturas electrónicas válidas ante el Ministerio de Hacienda.
---

# Generar facturas electrónicas

<a href="/settings/facturacion" target="_blank">
	Ir a Facturación →
</a>

IUSPRO te permite generar facturas electrónicas válidas ante el Ministerio de Hacienda de Costa Rica.

## Configurar tu cédula

Antes de generar facturas, debes configurar tu cédula:

1. Haz clic en tu **nombre o email** en la esquina inferior izquierda
2. Selecciona **"Preferencias"**
3. Ve a la pestaña **"Facturación"**
4. En la sección **"Información para Facturación Electrónica"**, ingresa tu cédula
5. Haz clic en **"Guardar Cédula"**

## Generar una factura

Una vez configurada tu cédula:

1. Ve al **Historial de Facturación**
2. Busca el cargo para el cual deseas generar factura
3. Haz clic en el botón **"Generar Factura"**
4. Confirma la generación en el modal que aparece

## Proceso de generación

- La factura se procesa en segundo plano
- **Puede tomar unos minutos** en generarse
- Recibirás la factura electrónica **por correo electrónico**
- Una vez generada, aparecerá la **clave numérica** en tu historial

## Notas importantes

- Solo puedes generar facturas para cargos que aún no tienen factura
- Si el estado muestra "Generando factura...", espera a que se complete el proceso
- Asegúrate de que tu cédula esté correctamente ingresada antes de solicitar la factura
